// TODO:(BW-888) - Remove Split
export const TIMESHEETS_PAGE_MIGRATION_SPLIT_NAME = "timetracking_initial_migration"
export const AUTHN_FOR_ANGULAR_QUERY_PARAM = "authForAngular";
export const USER_IS_CREW_MEMBER_KEY = 'USER_IS_CREW_MEMBER';
export const JWT_TOKEN_NAME = "bc.jwt"
export const BEARER_TOKEN_NAME = "bc.bearer"
export const CLIENTS_USER_GROUP = "EXTERNAL";
export const INTERNAL_USER_GROUP = "INTERNAL";
export const WEB_V1_URL_STAGING = "https://app.stg.bluecrewenv.com";
export const WEB_V1_URL_PROD = "https://app.stg.bluecrewenv.com";
export const WEB_V1_URL_LOCAL = "http://localhost";
